import angular from "angular";
import { WagePolicyModule } from "../../../wage-policy/wage-policy.module";
import { EmploymentRecordListEditorComponent } from "./employment-record-list-editor.component";
import { EmploymentRecordEditorComponent } from "./employment-record-editor.component";
import { EmploymentRecordEditContextFactory } from "./employment-record-edit-context.factory";
import { EmploymentOnboardingRecordEditorComponent } from "./employment-onboarding-record-editor.component";

export const EmploymentRecordEditorModule = angular
    .module("apex.mainApp.roster.edit.employmentRecordEditor", [
        WagePolicyModule
    ])
    .factory("employmentRecordEditContextFactory", EmploymentRecordEditContextFactory)
    .component("apexEmploymentRecordListEditor", EmploymentRecordListEditorComponent)
    .component("apexEmploymentRecordEditor", EmploymentRecordEditorComponent)
    .component("apexEmploymentOnboardingRecordEditor", EmploymentOnboardingRecordEditorComponent)
    .name;
